export interface NavLink {
  href: string;
  label: string;
}

/**
 * Makes sure the store is in the menu even when the saved menu in site
 * settings was made before the store existed. If the saved menu already has a
 * /store link, it is left alone, so its label and position still win.
 */
export function withStoreLink<T extends NavLink>(links: T[]): NavLink[] {
  if (links.some((l) => l.href === "/store" || l.href.startsWith("/store/"))) return links;
  const store: NavLink = { href: "/store", label: "Store" };
  const afterWebtools = links.findIndex((l) => l.href === "/webtools");
  const beforeBlog = links.findIndex((l) => l.href === "/blog");
  const at = afterWebtools >= 0 ? afterWebtools + 1 : beforeBlog >= 0 ? beforeBlog : links.length;
  return [...links.slice(0, at), store, ...links.slice(at)];
}
